<template>
  <div :class="classes">
    <pt-page-title title="咨询师" :isSearch="true" @search="search" @emptySearch="emptySearch"
                   :searchKey="searchKey">
      <template slot="before-left">
        <el-button type="primary" @click="goNew">新建咨询师</el-button>
      </template>
    </pt-page-title>
    <pt-page-factor-filter :labels="counselorTabLabels" v-model="params" isQueryRouter ref="filter"
                           @Filter="filter">
      <el-button type="primary" @click="filter()">筛选</el-button>
      <el-button type="primary" @click="exportAllCode" :loading="exportLoading">收款码批量导出</el-button>
      <el-button type="primary" @click="exportCounselors" :loading="exportCounselorsLoading">咨询师导出</el-button>
      <el-button type="primary" @click="exportHistoryAllCode">导出历史</el-button>
      <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
    </pt-page-factor-filter>
    <pt-counselor-table :class="$style['counselor-table']" :tableLabels="tableLabels"
                        :params-data="paramsData" ref="table" :isFromRouter="isFromRouter">
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row.id, scope.row)">详情</el-button>
          <el-button type="text" @click="goEdit(scope.row.id,scope.row)">编辑</el-button>
          <el-button type="text" @click="goDelete(scope.row.id,scope.row)">离职</el-button>
          <!-- <el-button type="text" @click="getQRcode(scope.row)"
                     v-if="isDownLoad(scope.row)">下载二维码</el-button> -->
        </template>
      </el-table-column>
    </pt-counselor-table>
  </div>
</template>

<script>
// 组件class前缀
import ptCounselorTable from './pt-counselor-table/withData'
import {
  counselorTabLabels,
  tableLabels
} from './counselor'
import {
  emptyObject
} from '@/utils/lifebankUtils'
const prefixCls = 'pt-counselor-manage'

export default {
  name: 'pt-counselor-manage',
  props: {
    newsCategories: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    positions: {
      type: Array,
      default: function () {
        return []
      }
    },
    companys: {
      type: Array,
      default: function () {
        return []
      }
    },
    exportLoading: Boolean,
    exportCounselorsLoading: Boolean
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableData () {
      return this.$refs.table.tableData
    }
  },
  data () {
    return {
      params: {},
      counselorTabLabels: counselorTabLabels,
      tableLabels: tableLabels,
      paramsData: this.tableParams,
      isFromRouter: false,
      searchKey: ''
    }
  },
  watch: {
    companys: {
      handler: function (val) {
        this.counselorTabLabels.forEach(item => {
          if (item.value === 'company') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    },
    positions: {
      handler: function (val) {
        this.counselorTabLabels.forEach(item => {
          if (item.value === 'position') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    ptCounselorTable
  },
  methods: {
    exportAllCode () {
      let data = { ...this.params }
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(_ => {
          this.$emit('exportAllCode', data)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportCounselors () {
      let data = { ...this.params }
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(_ => {
          this.$emit('exportCounselors', data)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryAllCode () {
      this.$router.push('/export-history/counselor-qr-code?name=counselor_user_zip_export')
    },
    // 是否有支付二维码（可下载二维码）
    isDownLoad (row) {
      return (row.paymentCode && row.paymentCode !== 'null') || (row.paymentCodes && row.paymentCodes.length)
    },
    cleanParams () {
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.filter()
    },
    emptySearch (val) {
      this.searchKey = null
      this.$delete(this.paramsData, 'searchKey')
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.$set(this.params, 'searchKey', val)
      this.$set(this.paramsData, 'searchKey', val)
    },
    filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      this.paramsData = { ...this.params }
      this.emptySearch()
    },
    goDetail (id, data) {
      // 跳转详情页面时直接将当前数据通过'value'传递，避免再次加载数据的请求。
      this.$router.push({ name: 'counselor-detail', params: { id: id, value: data } })
    },
    goEdit (id, data) {
      this.$router.push(`/counselor-form/true/${id}`)
    },
    goNew () {
      this.$router.push('/counselor-form/false/0')
    },
    goDelete (id, data) {
      this.$confirm('该咨询师离职后，该手机号对应的用户账户将解除咨询师的身份，被还原至普通用户身份，确认离职吗?', '离职提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        // this.$store.dispatch('deleteCounselor', id).then(res => {
        this.$store.dispatch('counselorDeparture', id).then(res => {
          this.reload()
          this.$message.success('成功设置咨询师”' + data.fullName + '“离职!')
        }).catch(err => {
          this.loading = false
          console.error(err)
          this.$message.error('设置咨询师离职失败!')
        })
      })
    },
    reload () {
      this.$refs.table && this.$refs.table.reload()
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .counselor-table{
    :global
    .el-button{
      margin-left: 0;
      margin-right:10px
    }
  }

</style>
